import { render, staticRenderFns } from "./DialogUncaughtError.vue?vue&type=template&id=35f5ce02&scoped=true&"
import script from "./DialogUncaughtError.vue?vue&type=script&lang=js&"
export * from "./DialogUncaughtError.vue?vue&type=script&lang=js&"
import style0 from "./DialogUncaughtError.vue?vue&type=style&index=0&id=35f5ce02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5ce02",
  null
  
)

export default component.exports